import { Button, Divider } from 'antd'
import { HStack, Icon, T, Tooltip, VStack } from 'govwell-ui'
import { IconKey } from 'govwell-ui/components/Icon/util'

import { getErrorName } from '../../../utils/file'

interface Props {
  actionLabel?: string
  actionIcon?: IconKey
  errorType: string | undefined
  name: string
  onClick: () => void
}

export const Error = ({
  actionLabel = 'Try again',
  actionIcon = 'FaRefresh',
  errorType,
  name,
  onClick,
}: Props) => {
  return (
    <VStack align="start" gap={2}>
      <HStack gap={2} justify="space-between">
        <T.Body className="text-left" maxLines={1}>
          {name}
        </T.Body>
        <HStack className="flex-0" gap={1}>
          <T.Body>
            <Icon.FaExclamationCircleSolid className="text-red-700" />
          </T.Body>
          <Tooltip content={actionLabel}>
            <Button type="text" icon={<Icon icon={actionIcon} />} onClick={onClick} />
          </Tooltip>
        </HStack>
      </HStack>

      {errorType && (
        <>
          <Divider className="!m-0" />
          <T.Body className="text-red-700">{getErrorName(errorType)}</T.Body>
        </>
      )}
    </VStack>
  )
}
